
const ENV = process.env.VUE_APP_ENV
export const APPID = ENV === 'production' ? 'wx520804b799e68366' : 'wx3b4ec1200ca54aa9'
export const ACTIVITYCODE = ENV === 'production' ? '62627f1c2a6f7341' : '8599cbf05e77647b'
// secret
export const APPSECRET = ENV === 'production' ? 'd5e8985f34e301e69510c5e51555380b' : '6a3c80ffefd27eedd3185743524723e1'
// orgId
export const ORGID = ENV === 'production' ? 'gh_1343a1dcee8e' : 'gh_b8d0afe477d5'
/**
 * 添加路由白名单，在此列表内的路由均无需判断登录
 * 值为路由的name值
 */
export let whiteList = new Set([
  '202103-public-invitation',
  'jump-wxapp',
  'orderResult',
  'landingpageIntroduce',
  'landingpageInvite',
  'landingpageSuccess',
  'landingpageFail',
  'referralActivityPage',
  'referralActivityFourPage',
  'acTouch',
  'actouchSuccess',
  'actouchFail',
  'inviteChinese',
  'chineseSuccess',
  'qrcoderedirectRed',
  'testPage',
  'testReview',
  'order',
  'orderError',
  'annualReport',
  'addWechat',
  'makeFriend',
  'makeFriendAdd',
  'conferenceQRCode',
  'change-child',
  'migrate'
])

/**
 * 添加localStorage字段
 * 在使用$setStorage、$getStorage、$clearStorage方法时，
 * 需要现在此添加key值才可以使用
 */
export let storage = new Set([
  'studentId',
  'posterUrl'
])

export default {
  env: ENV,
  appid: APPID,
  activityCode: ACTIVITYCODE,
  whiteList,
  storage
}
